import { defineMessages } from 'react-intl';

const messages = defineMessages({
  SellerLabelProviderId: {
    description: 'propertyCannotBeNullOrEmpty.sellerLabelProviderId',
    defaultMessage: 'Please select a shipping service.',
    id: '9vVEhN',
  },
  ServiceId: {
    description: 'propertyCannotBeNullOrEmpty.serviceId',
    defaultMessage: 'Please select a shipping service.',
    id: 'VDnuM5',
  },
  'Packages[0].PackageTypeId': {
    description: 'propertyCannotBeNullOrEmpty.packageTypeId',
    defaultMessage: 'Please select a package.',
    id: '4ma/rN',
  },
  'Packages[0].Weight': {
    description: 'propertyCannotBeNullOrEmpty.weight',
    defaultMessage: 'Please specify a weight.',
    id: '/zbUwj',
  },
  'ShipTo.Line1': {
    description: 'propertyCannotBeNullOrEmpty.shipToLine1',
    defaultMessage: 'Please provide a Ship To address.',
    id: 'rYIMtf',
  },
  'ShipTo.City': {
    description: 'propertyCannotBeNullOrEmpty.city',
    defaultMessage: 'Please provide a Ship To city.',
    id: 'BBxPHG',
  },
  'ShipTo.State': {
    description: 'propertyCannotBeNullOrEmpty.state',
    defaultMessage: 'Please provide a Ship To state.',
    id: 'F8Vqmz',
  },
  'ShipTo.PostalCode': {
    description: 'propertyCannotBeNullOrEmpty.potalCode',
    defaultMessage: 'Please provide a Ship To postal code.',
    id: 'vkWUqH',
  },
  'ShipTo.CountryCode': {
    description: 'propertyCannotBeNullOrEmpty.countryCode',
    defaultMessage: 'Please specify the Ship To country.',
    id: 'hrD8fJ',
  },
});

// Message ids for errors that are parcel-specific and must not surface on FreightLtl plans.
// Consumed by is-parcel-only-rate-error.ts. ShipTo.* ids are intentionally excluded — a freight
// shipment shares the same destination-address requirements and those errors remain visible.
export const PARCEL_ONLY_RATE_ERROR_IDS = Object.freeze([
  messages.SellerLabelProviderId.id,
  messages.ServiceId.id,
  messages['Packages[0].PackageTypeId'].id,
  messages['Packages[0].Weight'].id,
]);

export const propertyCannotBeNullOrEmpty = ({ propertyName }) => {
  const message = messages[propertyName];
  return message || null;
};
